/* ==========================================================================
   Gadea Loreak — Side-cart (carrito lateral)
   AJAX Cart API (/cart/*.js) + refresco de las zonas dinámicas del drawer
   leyendo /cart.js. Sin dependencias. Se auto-inicializa una sola vez.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__iuropCartInit) return;
  window.__iuropCartInit = true;

  var root, panel, overlay;
  var moneyFormat = '{{amount}}€';
  var giftThreshold = 4500;   // cents — regalo (tote bag) a partir de 45€; fallback: el valor real llega en data-gift-threshold del raíz #CartDrawer
  var giftVariant = '';       // variant id de la tote; '' = auto-add desactivado (se lee del drawer)
  var giftBusy = false;       // guard in-flight del auto-add/remove (evita bucles)
  var shipThreshold = 4900;   // cents — envío gratis
  var reserveSeconds = 600;   // 10:00 de reserva
  var timerId = null;
  var lastCartCount = null;   // para detectar AÑADIDOS (item_count sube) y renovar la reserva
  /* Último /cart.js recibido. Lo consulta el calendario de entrega para saber
     si el carrito lleva algún producto con antelación propia (ramos de novia). */
  var lastCartItems = [];

  /* ---------- utils ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function resizeImg(url, w) {
    if (!url) return '';
    if (/[?&]width=/.test(url)) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var f = format || moneyFormat || '{{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var rest = parts[1] ? decimal + parts[1] : '';
      return dollars + rest;
    }
    var match = f.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    return f.replace(placeholder, value);
  }

  /* ---------- open / close ---------- */
  function open() {
    if (!root) return;
    clearDiscountCookie();
    root.hidden = false;
    // fuerza reflow para que la transición corra
    void root.offsetWidth;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('iurop-cd-locked');
    startTimer();
    refresh();
    updateUpsellArrows(); // medible solo con el drawer visible
    // llamada de atención del selector de fecha: un pulso suave SOLO la
    // primera apertura de la sesión (que se descubra sin ser pesados)
    try {
      if (!sessionStorage.getItem('iuropDateNudged')) {
        sessionStorage.setItem('iuropDateNudged', '1');
        var dnr = $('[data-cd-open-calendar]', root);
        if (dnr) {
          dnr.classList.add('is-nudge');
          setTimeout(function () { dnr.classList.remove('is-nudge'); }, 2600);
        }
      }
    } catch (e) {}
    var closeBtn = $('[data-cart-close]', panel);
    if (closeBtn) { try { closeBtn.focus({ preventScroll: true }); } catch (e) {} }
  }
  function close() {
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('iurop-cd-locked');
    closeCalendar();
    var t = setTimeout(function () { if (!root.classList.contains('is-open')) root.hidden = true; }, 320);
  }
  function isOpen() { return root && root.classList.contains('is-open'); }

  /* ---------- AJAX cart ---------- */
  function getCart() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { 'Accept': 'application/json' }, credentials: 'same-origin'
    }).then(function (r) { return r.json(); });
  }
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (r) {
      // 422 (agotado/cantidad no disponible) y demás errores HTTP deben
      // RECHAZAR: si no, el body de error llegaba a renderCart y la línea
      // se quedaba en is-loading para siempre.
      if (!r.ok) {
        var err = new Error('Cart request failed: HTTP ' + r.status);
        err.status = r.status;
        throw err;
      }
      return r.json();
    });
  }
  function addItem(id, quantity, props) {
    var body = { id: id, quantity: quantity || 1 };
    if (props) body.properties = props;
    return postJSON('/cart/add.js', body);
  }
  /* Avisa al resto del tema (header, buscador, sticky ATC…) de que el carrito
     cambió. `source` evita que nuestro propio listener de 'cart:updated'
     vuelva a repintar en bucle. */
  function broadcast(cart) {
    if (!cart) return cart;
    try {
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart: cart, source: 'iurop-cart' }
      }));
    } catch (e) {}
    return cart;
  }

  /* Con un descuento automático BXGY activo, /cart/change.js sobre una línea
     que participa en el descuento la PARTE en dos líneas x1 en vez de subir la
     cantidad (comprobado en vivo: + en el ramo → ramo x1 + ramo x1). El cambio
     por VARIANTE con /cart/update.js consolida y no se parte. delta = ±1;
     quantity absoluto si delta es null. */
  function changeVariantQty(variantId, delta, absolute) {
    return getCart().then(function (cart) {
      var total = 0;
      for (var i = 0; i < cart.items.length; i++) {
        if (String(cart.items[i].variant_id) === String(variantId)) total += cart.items[i].quantity;
      }
      var target = absolute != null ? absolute : Math.max(0, total + delta);
      var updates = {};
      updates[variantId] = target;
      return postJSON('/cart/update.js', { updates: updates });
    }).then(function (cart) {
      renderCart(cart); broadcast(cart); return cart;
    }).catch(function () {
      $all('[data-cd-item].is-loading', root).forEach(function (el) { el.classList.remove('is-loading'); });
      return refresh().then(broadcast);
    });
  }
  function changeItem(key, quantity) {
    return postJSON('/cart/change.js', { id: key, quantity: quantity }).then(function (cart) {
      renderCart(cart); broadcast(cart); return cart;
    }).catch(function () {
      // Error (p.ej. 422): quita el estado de carga de las líneas y re-pinta
      // el carrito desde /cart.js limpio para volver a un estado coherente.
      $all('[data-cd-item].is-loading', root).forEach(function (el) { el.classList.remove('is-loading'); });
      return refresh().then(broadcast);
    });
  }
  function updateAttributes(attrs) {
    return postJSON('/cart/update.js', { attributes: attrs }).then(function (cart) {
      renderCart(cart); broadcast(cart); return cart;
    });
  }
  function refresh() { return getCart().then(function (c) { renderCart(c, true); return c; }); }

  /* ---------- regalo (tote) auto-add/remove ----------
     Solo actúa si data-gift-variant está relleno (si no, inerte). El umbral se
     evalúa EXCLUYENDO la propia tote; siempre 1 unidad; al bajar del umbral o
     vaciar el carrito, la tote se quita sola (QA §5.5). El precio real lo pone
     a 0 el descuento automático de Admin (BXGY), no este código. */
  function syncGift(cart) {
    if (!giftVariant || giftBusy || !cart || !cart.items) return;
    var total = 0, rest = cart.total_price;
    for (var i = 0; i < cart.items.length; i++) {
      if (String(cart.items[i].variant_id) === String(giftVariant)) {
        total += cart.items[i].quantity;
        rest -= cart.items[i].final_line_price;
      }
    }
    var done = function () { giftBusy = false; };
    /* Por VARIANTE con update.js: consolida también las líneas partidas por el
       descuento BXGY (dos totes x1 → una) y clava la cantidad a 1 o 0. */
    var objetivo = rest >= giftThreshold ? 1 : 0;
    if (total !== objetivo) {
      giftBusy = true;
      var updates = {}; updates[giftVariant] = objetivo;
      postJSON('/cart/update.js', { updates: updates }).then(function (c) { renderCart(c); broadcast(c); }).catch(function () {}).then(done);
    }
  }

  /* ---------- render ---------- */
  /* Variante escogida (tamaño/color…) + personalizaciones de la línea.
     /cart.js devuelve variant_title = null cuando el producto no tiene
     opciones reales ('Default Title'), así que ese caso no pinta nada.
     Mismo criterio y mismas clases que el render Liquid del snippet. */
  function itemMetaHTML(item) {
    var out = '';
    var vt = item.variant_title;
    if (vt && vt !== 'Default Title') {
      out += '<span class="iurop-cd__item-variant">' + esc(vt) + '</span>';
    }
    var props = item.properties;
    if (props) {
      Object.keys(props).forEach(function (k) {
        if (!k || k.charAt(0) === '_') return;      // propiedades internas
        var v = props[k];
        if (v == null || v === '') return;
        out += '<span class="iurop-cd__item-variant">' + esc(k) + ': ' + esc(v) + '</span>';
      });
    }
    return out;
  }

  function itemHTML(item, index) {
    var img = item.image ? '<img class="iurop-cd__item-img" src="' + esc(resizeImg(item.image, 160)) + '" alt="' + esc(item.product_title || item.title) + '" width="80" height="80" loading="lazy">'
      : '<span class="iurop-cd__item-img iurop-cd__item-img--ph"></span>';
    return '' +
      '<li class="iurop-cd__item" data-cd-item data-key="' + esc(item.key) + '" data-variant="' + esc(item.variant_id) + '">' +
        '<a class="iurop-cd__item-media" href="' + esc(item.url) + '">' + img + '</a>' +
        '<div class="iurop-cd__item-main">' +
          '<div class="iurop-cd__item-info">' +
            '<a class="iurop-cd__item-title" href="' + esc(item.url) + '">' + esc(item.product_title || item.title) + '</a>' +
            itemMetaHTML(item) +
            (String(item.variant_id) === String(giftVariant) && lastGiftQualifies ? '<span class="iurop-cd__item-price iurop-cd__item-price--free">' + esc((root.dataset && root.dataset.txtGratis) || 'GRATIS') + '</span>' : '<span class="iurop-cd__item-price">' + formatMoney(item.final_line_price) + '</span>') +
            '<div class="iurop-cd__stepper" data-cd-stepper>' +
              '<button type="button" class="iurop-cd__step iurop-cd__step--minus" data-cd-minus aria-label="Quitar una unidad">&minus;</button>' +
              '<span class="iurop-cd__qty" data-cd-qty>' + item.quantity + '</span>' +
              '<button type="button" class="iurop-cd__step iurop-cd__step--plus" data-cd-plus aria-label="Añadir una unidad">+</button>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="iurop-cd__item-remove" data-cd-remove aria-label="Eliminar del carrito">' +
            // mismo icono (Material relleno 20px) que el render Liquid de snippets/iurop-cart-drawer.liquid
            '<svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12ZM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4Z"/></svg>' +
          '</button>' +
        '</div>' +
      '</li>';
  }

  /* Subtotal de la barra sin la línea de la tote (coherente con el Liquid). */
  /* El descuento del regalo es un CÓDIGO (TOTE45) auto-aplicado por cookie: un
     descuento AUTOMÁTICO BXGY hacía que el motor del carrito PARTIERA las
     líneas al cambiar cantidades (+ → dos líneas x1). El fetch a /discount/X
     siembra la cookie y el checkout lo aplica solo. */
  var lastGiftQualifies = false;
  function clearDiscountCookie() {
    /* La cookie discount_code no es httpOnly: se puede limpiar desde JS. Con
       ella puesta, cambiar cantidades PARTE las líneas del carrito. */
    try { document.cookie = 'discount_code=; Max-Age=0; path=/'; } catch (e) {}
  }
  function giftCheckoutUrl(fallback) {
    /* URL de checkout con el código sembrado por el SERVIDOR (redirect 302 de
       /discount/COD): atómico — sin carrera fetch→navegar. */
    var code = (root && root.dataset && root.dataset.giftCode) || '';
    if (!code || !lastGiftQualifies) return fallback;
    return '/discount/' + encodeURIComponent(code) + '?redirect=%2Fcheckout';
  }
  function progressSubtotal(cart) {
    var st = cart.total_price;
    if (giftVariant) {
      for (var i = 0; i < (cart.items || []).length; i++) {
        if (String(cart.items[i].variant_id) === String(giftVariant)) st -= cart.items[i].final_line_price;
      }
    }
    return st;
  }
  function progressHTML(subtotal) {
    /* Barra con DOS objetivos y escala por TRAMOS (los iconos quedaban casi
       pegados con la escala lineal): 0→tote = 0→62% visual; tote→envío =
       62→100%. El TEXTO va en cascada: primero el objetivo de la tote y, una
       vez conseguida, el del envío gratis. Textos en data-txt-* del raíz. */
    var GIFT_POS = 62;
    var pct;
    if (subtotal <= giftThreshold || shipThreshold <= giftThreshold) {
      pct = giftThreshold > 0 ? Math.min(GIFT_POS, (subtotal / giftThreshold) * GIFT_POS) : 0;
    } else {
      pct = GIFT_POS + Math.min(100 - GIFT_POS, ((subtotal - giftThreshold) / (shipThreshold - giftThreshold)) * (100 - GIFT_POS));
    }
    var giftDone = subtotal >= giftThreshold;
    var shipDone = subtotal >= shipThreshold;
    var T = (root && root.dataset) || {};
    var giftName = T.txtGiftName || 'tote bag de regalo';
    var line;
    if (!giftDone) {
      line = (T.txtGiftPre || 'Te faltan') + ' <strong>' + formatMoney(giftThreshold - subtotal) + '</strong> ' + (T.txtGiftPost || 'para tu') + ' <strong>' + giftName + '</strong>';
    } else if (!shipDone) {
      line = (T.txtShipPre || 'Te faltan') + ' <strong>' + formatMoney(shipThreshold - subtotal) + '</strong> ' + (T.txtShipPost || 'para conseguir el envío gratis!');
    } else {
      line = '<strong>' + (T.txtShipDone || '¡Has conseguido el envío gratis!') + '</strong>';
    }
    return '' +
      '<div class="iurop-cd__progress-text"><p>' + line + '</p></div>' +
      '<div class="iurop-cd__bar">' +
        '<span class="iurop-cd__bar-fill" style="width:' + pct.toFixed(2) + '%"></span>' +
        '<span class="iurop-cd__bar-marker' + (giftDone ? ' is-done' : '') + '" style="left:' + GIFT_POS + '%" title="Tote bag de regalo">' + giftSVG() + '</span>' +
        '<span class="iurop-cd__bar-marker' + (shipDone ? ' is-done' : '') + '" style="left:100%" title="Envío gratis">' + truckSVG() + '</span>' +
      '</div>';
  }
  // Mismos iconos que el render Liquid (side-cart de Figma: bolsa local_mall 15703:18101
  // y camión local_shipping 15703:18097). Si cambias uno, cambia el otro.
  function giftSVG() {
    return '<svg viewBox="5 4 16 16" width="15" height="15" fill="currentColor" aria-hidden="true"><path d="M8.74367 18C8.44533 18 8.19122 17.8951 7.98133 17.6853C7.77156 17.4754 7.66667 17.2213 7.66667 16.923V9.74367C7.66667 9.44533 7.77156 9.19122 7.98133 8.98133C8.19122 8.77156 8.44533 8.66667 8.74367 8.66667H10.3333C10.3333 7.92389 10.5921 7.29378 11.1097 6.77633C11.6271 6.25878 12.2572 6 13 6C13.7428 6 14.3729 6.25878 14.8903 6.77633C15.4079 7.29378 15.6667 7.92389 15.6667 8.66667H17.2563C17.5547 8.66667 17.8088 8.77156 18.0187 8.98133C18.2284 9.19122 18.3333 9.44533 18.3333 9.74367V16.923C18.3333 17.2213 18.2284 17.4754 18.0187 17.6853C17.8088 17.8951 17.5547 18 17.2563 18H8.74367ZM8.74367 17.3333H17.2563C17.359 17.3333 17.4531 17.2906 17.5385 17.2052C17.6239 17.1197 17.6667 17.0257 17.6667 16.923V9.74367C17.6667 9.641 17.6239 9.54694 17.5385 9.4615C17.4531 9.37606 17.359 9.33333 17.2563 9.33333H8.74367C8.641 9.33333 8.54694 9.37606 8.4615 9.4615C8.37606 9.54694 8.33333 9.641 8.33333 9.74367V16.923C8.33333 17.0257 8.37606 17.1197 8.4615 17.2052C8.54694 17.2906 8.641 17.3333 8.74367 17.3333ZM14.8903 11.8903C15.4079 11.3729 15.6667 10.7428 15.6667 10H15C15 10.5556 14.8056 11.0278 14.4167 11.4167C14.0278 11.8056 13.5556 12 13 12C12.4444 12 11.9722 11.8056 11.5833 11.4167C11.1944 11.0278 11 10.5556 11 10H10.3333C10.3333 10.7428 10.5921 11.3729 11.1097 11.8903C11.6271 12.4079 12.2572 12.6667 13 12.6667C13.7428 12.6667 14.3729 12.4079 14.8903 11.8903ZM11 8.66667H15C15 8.11111 14.8056 7.63889 14.4167 7.25C14.0278 6.86111 13.5556 6.66667 13 6.66667C12.4444 6.66667 11.9722 6.86111 11.5833 7.25C11.1944 7.63889 11 8.11111 11 8.66667Z"/></svg>';
  }
  function truckSVG() {
    return '<svg viewBox="5 4.5 16 16" width="15" height="15" fill="currentColor" aria-hidden="true"><path d="M8.82061 16.68C8.49617 16.3542 8.33394 15.9609 8.33394 15.5H6.84728L6.99261 14.8333H8.50461C8.62505 14.5369 8.8195 14.296 9.08794 14.1107C9.35639 13.9258 9.66061 13.8333 10.0006 13.8333C10.3406 13.8333 10.6451 13.9258 10.9139 14.1107C11.1819 14.296 11.3762 14.5369 11.4966 14.8333H14.5753L16.0393 8.5H8.73928L8.75461 8.43467C8.78705 8.26044 8.8715 8.11667 9.00794 8.00333C9.14439 7.89 9.30528 7.83333 9.49061 7.83333H16.8726L16.3326 10.1667H17.7186L19.5266 12.5773L18.9493 15.5H18.1799C18.1799 15.9618 18.0177 16.3551 17.6933 16.68C17.3688 17.0049 16.9755 17.1671 16.5133 17.1667C16.0511 17.1662 15.6579 17.004 15.3339 16.68C15.0099 16.356 14.8477 15.9627 14.8473 15.5H11.6673C11.6673 15.9618 11.5051 16.3551 11.1806 16.68C10.8562 17.0049 10.4628 17.1671 10.0006 17.1667C9.53839 17.1662 9.14505 17.004 8.82061 16.68ZM15.5919 13.3333H18.6933L18.8113 12.74L17.3853 10.8333H16.1733L15.5919 13.3333ZM6.11528 13.1653L6.28194 12.4987H9.26861L9.10194 13.1653H6.11528ZM7.44861 10.8347L7.61528 10.168H11.2686L11.1019 10.8347H7.44861ZM10.0006 16.5C10.2748 16.5 10.5102 16.402 10.7066 16.206C10.9026 16.0096 11.0006 15.7742 11.0006 15.5C11.0006 15.2258 10.9026 14.9904 10.7066 14.794C10.5106 14.5976 10.2753 14.4996 10.0006 14.5C9.72594 14.5004 9.49061 14.5984 9.29461 14.794C9.09861 14.9904 9.00061 15.2258 9.00061 15.5C9.00061 15.7742 9.09861 16.0096 9.29461 16.206C9.49105 16.402 9.72639 16.5 10.0006 16.5ZM16.5139 16.5C16.7882 16.5 17.0233 16.402 17.2193 16.206C17.4153 16.0096 17.5133 15.7742 17.5133 15.5C17.5133 15.2258 17.4153 14.9904 17.2193 14.794C17.0233 14.5976 16.7879 14.4996 16.5133 14.5C16.2386 14.5004 16.0035 14.5984 15.8079 14.794C15.6115 14.9904 15.5133 15.2258 15.5133 15.5C15.5133 15.7742 15.6113 16.0096 15.8073 16.206C16.0037 16.402 16.2393 16.5 16.5139 16.5Z"/></svg>';
  }

  /* ---------- contadores ----------
     ÚNICO punto que escribe el número de artículos: badge del drawer
     ([data-cd-count]) + burbuja(s) del header ([data-cart-count], fuera del
     drawer → se buscan en document). Se llama en CADA render, así que añadir,
     quitar, cambiar cantidad o vaciar lo refresca siempre. */
  function syncCounters(count) {
    var n = typeof count === 'number' && isFinite(count) ? count : 0;
    $all('[data-cd-count]', root).forEach(function (el) { el.textContent = n; });
    $all('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      // el header oculta la burbuja cuando el carrito está vacío
      if (n > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
  }

  function renderCart(cart, fromRefresh) {
    lastCartItems = (cart && cart.items) || [];
    /* ¿El regalo cumple? (subtotal sin la tote ≥ umbral) — para pintar GRATIS.
       OJO: el código NO se aplica aquí: con la cookie del descuento puesta, el
       motor del carrito PARTE las líneas al cambiar cantidades (probado). La
       cookie se siembra SOLO al pulsar "Finalizar compra". */
    var giftQualifies = giftVariant ? (progressSubtotal(cart) >= giftThreshold) : false;
    lastGiftQualifies = giftQualifies;
    if (!root || !cart || !cart.items) return;
    // Payload incompleto (p.ej. la respuesta de /cart/add.js, que trae items
    // pero NO item_count ni total_price): re-leer /cart.js en vez de pintar
    // "undefined" en el contador y dejar el subtotal en blanco. `fromRefresh`
    // corta la recursión si /cart.js devolviera algo raro.
    if (typeof cart.item_count !== 'number' || typeof cart.total_price !== 'number') {
      if (!fromRefresh) refresh();
      return;
    }
    var empty = cart.item_count === 0;
    root.classList.toggle('is-empty', empty);

    // contador (badge del drawer + burbujas externas del header)
    syncCounters(cart.item_count);

    // líneas de producto
    var list = $('[data-cd-items]', root);
    if (list) list.innerHTML = cart.items.map(itemHTML).join('');

    // progreso
    var prog = $('[data-cd-progress]', root);
    if (prog) prog.innerHTML = progressHTML(progressSubtotal(cart));

    // subtotal MOSTRADO: si la tote de regalo cumple, se resta su línea (el
    // checkout la pone a 0€ con el código; enseñar los 4€ aquí es "cobrarla")
    var displayTotal = giftQualifies ? progressSubtotal(cart) : cart.total_price;
    $all('[data-cd-subtotal]', root).forEach(function (el) { el.textContent = formatMoney(displayTotal); });

    // porcentaje del bloque de upsells: dinámico por producto y ESTABLE, con la
    // MISMA fórmula que el render Liquid (primer producto del carrito, 78-92).
    // Sin esto el título se quedaba con el valor de la carga inicial (83 con el
    // carrito vacío) tras añadir/quitar por AJAX.
    var pctEl = $('[data-cd-upsell-pct]', root);
    var pctId = cart.items.length ? cart.items[0].product_id : null;
    if (pctEl && typeof pctId === 'number' && isFinite(pctId)) pctEl.textContent = String((pctId % 15) + 78);

    // banner de reserva vs vacío: cada AÑADIDO (item_count sube) renueva la
    // reserva venga de donde venga el add (PDP, sticky, quick-add, upsell);
    // vaciar borra la marca para que el próximo carrito arranque de cero
    var reserved = $('[data-cd-reserved]', root);
    if (reserved) {
      if (empty) {
        clearReserve();
      } else {
        if (lastCartCount != null && cart.item_count > lastCartCount) resetReserve();
        else startTimer();
      }
    }
    lastCartCount = cart.item_count;

    // fecha de entrega guardada (con método: domicilio vs recogida). La fila
    // tiene título + subtítulo; el textContent a pelo destruiría el markup.
    var dl = $('[data-cd-open-calendar]', root);
    if (dl) {
      var d = cart.attributes && cart.attributes['Fecha de entrega'];
      var meth = cart.attributes && cart.attributes['Método de entrega'];
      if (meth) calState.method = meth; // restaura el método guardado para el calendario
      /* Fecha caducada (carrito aparcado días, o se añadió después un producto
         con más antelación): se borra y se pide elegir de nuevo. */
      if (d && !empty && !dateBusy && isStaleDate(cart)) {
        dateBusy = true;
        d = null;
        calState.selected = null;
        postJSON('/cart/update.js', { attributes: { 'Fecha de entrega': '', 'Punto de recogida': '', '_fecha_iso': '' } })
          .then(function (c) { dateBusy = false; showDateWarning(); renderCart(c); broadcast(c); })
          .catch(function () { dateBusy = false; });
      } else if (d) {
        hideDateWarning();
      }
      var dlMain = dl.querySelector('[data-cd-date-main]');
      var dlSub = dl.querySelector('[data-cd-date-sub]');
      var ds = root.dataset || {};
      if (dlMain) dlMain.textContent = d ? ((meth ? meth + ' · ' : '') + d) : (ds.txtDateLink || 'Elige el día de entrega');
      if (dlSub) dlSub.textContent = d ? (ds.txtDateSubSet || 'Toca para cambiar el día') : (ds.txtDateSub || 'Envío a domicilio o recogida en tienda');
      if (!dlMain) dl.textContent = d ? ((meth ? meth + ' · ' : '') + d) : (ds.txtDateLink || 'Elige el día de entrega');
      dl.classList.toggle('is-set', !!d);
    }

    // regalo tote: mantener sincronizado con el umbral (inerte sin data-gift-variant)
    syncGift(cart);

    // flechas de upsells (el alto/ancho del panel puede cambiar con las líneas)
    updateUpsellArrows();
  }

  /* ---------- reserva (cuenta atrás) ----------
     Cada artículo AÑADIDO renueva la reserva (QA: «el contador no se
     reinicia» — la marca caducada de sessionStorage se quedaba para siempre
     y toda apertura posterior pintaba 0:00 congelado). Expirada sin añadidos
     nuevos, la barra se OCULTA (un 0:00 muerto parece un bug); el siguiente
     añadido la re-arma y la vuelve a mostrar. Vaciar el carrito borra la
     marca para que el próximo carrito arranque con la reserva completa. */
  function resetReserve() {
    try { sessionStorage.setItem('iuropCartReserveEnd', String(Date.now() + reserveSeconds * 1000)); } catch (e) {}
    stopTimer();
    startTimer();
  }
  function clearReserve() {
    stopTimer();
    try { sessionStorage.removeItem('iuropCartReserveEnd'); } catch (e) {}
  }
  function startTimer() {
    var el = $('[data-cd-timer]', root);
    if (!el) return;
    if (timerId) return;
    var bar = $('[data-cd-reserved]', root);
    var end = parseInt(sessionStorage.getItem('iuropCartReserveEnd') || '0', 10);
    if (!end) { end = Date.now() + reserveSeconds * 1000; try { sessionStorage.setItem('iuropCartReserveEnd', String(end)); } catch (e) {} }
    function tick() {
      var remaining = Math.round((end - Date.now()) / 1000);
      if (remaining <= 0) {
        el.textContent = '0:00';
        if (bar) bar.style.display = 'none'; // la clase trae display:flex → inline
        stopTimer();
        return false;
      }
      if (bar && bar.style.display === 'none') bar.style.display = '';
      var m = Math.floor(remaining / 60), s = remaining % 60;
      el.textContent = m + ':' + (s < 10 ? '0' + s : s);
      return true;
    }
    if (tick()) timerId = setInterval(tick, 1000);
  }
  function stopTimer() { if (timerId) { clearInterval(timerId); timerId = null; } }

  /* ---------- calendario de entrega ---------- */
  var calState = { view: new Date(), selected: null, method: 'Envío a domicilio' };

  /* Reglas de entrega (config desde Ajustes del tema › Entrega). Se declara
     ANTES que MONTHS porque los nombres de mes también llegan del config. */
  var DCFG = (function () { try { var el = document.querySelector('[data-cd-delivery-config]'); return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; } })();
  var MONTHS = (DCFG.monthNames && DCFG.monthNames.length === 12)
    ? DCFG.monthNames
    : ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
  /* Antelación de entrega — regla de negocio VIGENTE (QA17, sustituye al
     antiguo suelo de 3 días laborables): pedidos ANTES de la hora de corte
     (12:00) llegan al día laborable SIGUIENTE (lead 1); DESPUÉS del corte,
     un día laborable más (lead 1 + 1 = 2). Se saltan findes y festivos
     (nacionales + fechas bloqueadas). Aplica IGUAL a envío a domicilio y a
     recogida en tienda (mismo earliest). El comerciante puede SUBIR la
     antelación desde Ajustes del tema › Entrega; 1 es el suelo. */
  var MIN_LEAD_DAYS = 1;
  var DELIV = {
    cutoffHour: DCFG.cutoffHour != null ? DCFG.cutoffHour : 12,
    leadDays: Math.max(MIN_LEAD_DAYS, DCFG.leadDays != null ? DCFG.leadDays : MIN_LEAD_DAYS),
    maxMonths: DCFG.maxMonths != null ? DCFG.maxMonths : 3,
    blockNat: DCFG.blockNationalHolidays !== false,
    pickupAddress: DCFG.pickupAddress || 'Calle José María Escuza 27, Bilbao (Bizkaia)',
    blocked: (function (s) { var set = {}; (s || '').split(/[\s,;]+/).forEach(function (x) { x = x.trim(); if (/^\d{4}-\d{2}-\d{2}$/.test(x)) set[x] = 1; }); return set; })(DCFG.blockedDates)
  };
  /* Productos con antelación PROPIA (hoy: la colección 'novias', que se monta a
     medida). El calendario coge el plazo del producto más lento que haya en el
     carrito y apaga las fechas anteriores. Un carrito sin ninguno se comporta
     exactamente como antes: slowExtraLead() devuelve 0. */
  DELIV.slowLead = DCFG.slowLeadDays != null ? DCFG.slowLeadDays : 0;
  DELIV.slowIds = (function (s) {
    var set = {};
    String(s || '').split(',').forEach(function (x) { x = x.trim(); if (x) set[x] = 1; });
    return set;
  })(DCFG.slowProductIds);
  function slowExtraLead() {
    if (!DELIV.slowLead) return 0;
    for (var i = 0; i < lastCartItems.length; i++) {
      if (DELIV.slowIds[String(lastCartItems[i].product_id)]) return DELIV.slowLead;
    }
    return 0;
  }
  function isoDate(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
  function isWeekend(d) { var w = d.getDay(); return w === 0 || w === 6; }
  var _natCache = {};
  function nationalHolidays(y) {
    if (_natCache[y]) return _natCache[y];
    var set = {};
    ['01-01', '01-06', '05-01', '08-15', '10-12', '11-01', '12-06', '12-08', '12-25'].forEach(function (md) { set[y + '-' + md] = 1; });
    // Viernes Santo = Domingo de Pascua − 2 (algoritmo gregoriano anónimo)
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, dd = Math.floor(b / 4), e = b % 4,
      f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3),
      h = (19 * a + b - dd - g + 15) % 30, i = Math.floor(c / 4), k = c % 4,
      l = (32 + 2 * e + 2 * i - h - k) % 7, mm = Math.floor((a + 11 * h + 22 * l) / 451),
      mo = Math.floor((h + l - 7 * mm + 114) / 31), da = ((h + l - 7 * mm + 114) % 31) + 1;
    var gf = new Date(y, mo - 1, da); gf.setDate(gf.getDate() - 2);
    set[isoDate(gf)] = 1;
    _natCache[y] = set; return set;
  }
  function isHoliday(d) { var s = isoDate(d); if (DELIV.blocked[s]) return true; return DELIV.blockNat && !!nationalHolidays(d.getFullYear())[s]; }
  function isBlockedDay(d) { return isWeekend(d) || isHoliday(d); }
  function earliestDate() {
    var now = new Date();
    /* La hora de corte solo existe en días LABORABLES: un pedido de sábado,
       domingo o festivo cuenta como pedido del siguiente laborable a primera
       hora (antes del corte). Sin esto, el sábado por la mañana ofrecía el
       lunes como primera fecha, como si el pedido se preparase en finde
       (QA: no contar sábados y domingos como laborables). */
    var eff = new Date(now);
    while (isBlockedDay(eff)) { eff.setDate(eff.getDate() + 1); eff.setHours(0, 0, 0, 0); }
    // antes del corte: +1 día laborable (lead 1); después: +1 extra (total 2)
    var lead = Math.max(MIN_LEAD_DAYS, DELIV.leadDays) + (eff.getHours() >= DELIV.cutoffHour ? 1 : 0) + slowExtraLead();
    var d = new Date(eff); d.setHours(0, 0, 0, 0);
    while (lead > 0) { d.setDate(d.getDate() + 1); if (!isBlockedDay(d)) lead--; } // solo laborables
    return d;
  }
  function maxDeliveryDate() { var d = new Date(); d.setHours(0, 0, 0, 0); d.setMonth(d.getMonth() + DELIV.maxMonths); return d; }

  /* ---------- caducidad de la fecha guardada ----------
     Los atributos del carrito sobreviven días: un carrito aparcado el lunes
     llega al viernes con la fecha del martes todavía puesta, y el pedido se
     cerraba con ella (caso real: pedido entrado a las 13:11, después del corte,
     con la fecha del día siguiente). Aquí se revalida contra earliestDate() —
     que ya tiene en cuenta corte, findes, festivos y productos lentos del
     carrito — y, si ya no vale, se BORRA del carrito y se avisa. Nunca se
     elige una fecha nueva en nombre del cliente: se le pide que vuelva a
     elegir. */
  var dateBusy = false;   // guard in-flight del borrado (evita bucle con renderCart)

  /* '16 octubre 2026' -> Date. Si no se entiende (otro idioma, formato raro),
     devuelve null y NO se toca nada: borrar a ciegas sería peor que el bug. */
  function parseStoredDate(human) {
    if (!human) return null;
    var s = String(human).trim().toLowerCase();
    var iso = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
    if (iso) {
      var di = new Date(+iso[1], +iso[2] - 1, +iso[3]); di.setHours(0, 0, 0, 0);
      return isNaN(di.getTime()) ? null : di;
    }
    var m = s.match(/^(\d{1,2})\s+(\S+)\s+(\d{4})$/);
    if (!m) return null;
    var idx = -1;
    for (var i = 0; i < MONTHS.length; i++) { if (String(MONTHS[i]).toLowerCase() === m[2]) { idx = i; break; } }
    if (idx < 0) return null;
    var d = new Date(+m[3], idx, +m[1]); d.setHours(0, 0, 0, 0);
    return isNaN(d.getTime()) ? null : d;
  }

  /* Prioriza el ISO interno (_fecha_iso) que escribe saveDate; para carritos
     anteriores a este cambio cae al texto humano del atributo visible. */
  function storedDate(cart) {
    var a = (cart && cart.attributes) || {};
    return parseStoredDate(a['_fecha_iso']) || parseStoredDate(a['Fecha de entrega']);
  }
  function isStaleDate(cart) {
    var d = storedDate(cart);
    if (!d) return false;
    if (isBlockedDay(d)) return true;      // festivo o fecha bloqueada a posteriori
    return d < earliestDate();             // ya no cumple la antelación mínima
  }

  /* Aviso bajo la fila de la fecha. Se crea desde JS (estilos en línea) para
     no tener que tocar el snippet del drawer ni la hoja de estilos. */
  function dateWarningEl() {
    var dl = $('[data-cd-open-calendar]', root);
    if (!dl) return null;
    var w = $('[data-cd-date-warning]', root);
    if (!w) {
      w = document.createElement('p');
      w.setAttribute('data-cd-date-warning', '');
      w.className = 'iurop-cd__date-warning';
      w.style.cssText = 'margin:8px 0 0;padding:8px 10px;border-radius:8px;font-size:13px;line-height:1.4;background:#FDF3E3;color:#7A4B12;';
      (dl.parentNode || root).insertBefore(w, dl.nextSibling);
    }
    return w;
  }
  function showDateWarning() {
    var w = dateWarningEl();
    if (!w) return;
    w.textContent = (root.dataset && root.dataset.txtDateStale) ||
      'La fecha que habías elegido ya no está disponible. Elige un nuevo día de entrega.';
    w.hidden = false;
  }
  function hideDateWarning() {
    var w = $('[data-cd-date-warning]', root);
    if (w) w.hidden = true;
  }

  /* Revisión al CARGAR la página, sin abrir el drawer: cubre al cliente que
     vuelve días después y va directo a 'Finalizar compra' desde la cabecera. */
  function revalidateStoredDate() {
    getCart().then(function (cart) {
      if (!cart || !cart.item_count) return;
      lastCartItems = cart.items || [];                 // lo necesita slowExtraLead()
      if (!isStaleDate(cart)) return;
      dateBusy = true;
      calState.selected = null;
      return postJSON('/cart/update.js', { attributes: { 'Fecha de entrega': '', 'Punto de recogida': '', '_fecha_iso': '' } })
        .then(function (c) {
          dateBusy = false;
          /* Este repintado ocurre en la carga de la página, con el drawer
             cerrado: no debe disparar el auto-add de la tote de regalo (el
             contador del carrito subiría solo, sin que el cliente lo toque).
             giftBusy es el guard que ya respeta syncGift. */
          var g = giftBusy; giftBusy = true;
          renderCart(c);
          giftBusy = g;
          broadcast(c);
          showDateWarning();
        })
        .catch(function () { dateBusy = false; });
    }).catch(function () {});
  }

  function openCalendar() {
    var cal = $('[data-cd-calendar]', root);
    if (!cal) return;
    cal.hidden = false;
    void cal.offsetWidth;
    cal.classList.add('is-open');
    cal.setAttribute('aria-hidden', 'false');
    // Abrir en el mes de la fecha elegida o, si no hay, en el primer mes con días disponibles
    var startFrom = calState.selected ? new Date(calState.selected + 'T00:00:00') : earliestDate();
    calState.view = new Date(startFrom.getFullYear(), startFrom.getMonth(), 1);
    // Refleja el método guardado: pestaña activa + panel de recogida
    $all('[data-cd-method]', root).forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-cd-method') === calState.method); });
    var pinfo = $('[data-cd-pickup-info]', root);
    if (pinfo) pinfo.hidden = (calState.method !== 'Recogida en tienda');
    buildCalendar();
  }
  function closeCalendar() {
    var cal = $('[data-cd-calendar]', root);
    if (!cal) return;
    cal.classList.remove('is-open');
    cal.setAttribute('aria-hidden', 'true');
    setTimeout(function () { if (!cal.classList.contains('is-open')) cal.hidden = true; }, 300);
  }
  function buildCalendar() {
    var grid = $('[data-cd-cal-grid]', root);
    var label = $('[data-cd-cal-month]', root);
    if (!grid || !label) return;
    var y = calState.view.getFullYear(), m = calState.view.getMonth();
    label.textContent = MONTHS[m] + ' ' + y;
    var first = new Date(y, m, 1);
    var startDow = (first.getDay() + 6) % 7; // lunes = 0
    var daysInMonth = new Date(y, m + 1, 0).getDate();
    var today = new Date(); today.setHours(0, 0, 0, 0);
    var minD = earliestDate(), maxD = maxDeliveryDate();
    var html = '';
    for (var i = 0; i < startDow; i++) html += '<span class="iurop-cd__cal-day is-empty"></span>';
    for (var d = 1; d <= daysInMonth; d++) {
      var date = new Date(y, m, d);
      var iso = isoDate(date);
      var disabled = date < minD || date > maxD || isBlockedDay(date);
      var isToday = date.getTime() === today.getTime();
      var sel = calState.selected === iso;
      html += '<button type="button" class="iurop-cd__cal-day' +
        (disabled ? ' is-disabled' : '') + (isToday ? ' is-today' : '') + (sel ? ' is-selected' : '') +
        '"' + (disabled ? ' disabled' : '') + ' data-cd-cal-date="' + iso + '">' + d + '</button>';
    }
    grid.innerHTML = html;
    // Clamp de la navegación de mes al rango permitido [mes del mínimo, mes del máximo]
    var pv = $('[data-cd-cal-prev]', root), nx = $('[data-cd-cal-next]', root);
    if (pv) pv.disabled = (y < minD.getFullYear()) || (y === minD.getFullYear() && m <= minD.getMonth());
    if (nx) nx.disabled = (y > maxD.getFullYear()) || (y === maxD.getFullYear() && m >= maxD.getMonth());
  }
  function saveDate() {
    if (!calState.selected) { closeCalendar(); return; }
    /* Por si el calendario llevaba abierto al cruzar la hora de corte: lo que
       se guarda se vuelve a validar en el instante de guardar. */
    var sel = new Date(calState.selected + 'T00:00:00');
    if (isBlockedDay(sel) || sel < earliestDate()) {
      calState.selected = null;
      buildCalendar();
      showDateWarning();
      return;
    }
    var parts = calState.selected.split('-');
    var human = parseInt(parts[2], 10) + ' ' + MONTHS[parseInt(parts[1], 10) - 1].toLowerCase() + ' ' + parts[0];
    /* _fecha_iso: copia en ISO para poder revalidar sin depender del idioma
       del texto visible. */
    var attrs = { 'Fecha de entrega': human, 'Método de entrega': calState.method, '_fecha_iso': calState.selected };
    hideDateWarning();
    // Recogida en tienda → guardar el punto de recogida en el pedido (vacío lo elimina)
    attrs['Punto de recogida'] = calState.method === 'Recogida en tienda' ? DELIV.pickupAddress : '';
    updateAttributes(attrs);
    closeCalendar();
  }

  /* ---------- upsells: recorrido en desktop (rueda + arrastre) ---------- */
  // La fila .iurop-cd__upsell-row tiene overflow-x con scrollbar oculta: sin
  // esto era irrecorrible con ratón. Listeners DELEGADOS en el root para que
  // sobrevivan al re-render AJAX. Touch NO se toca (scroll nativo).
  var upsellDrag = null;

  function upsellRowFrom(target) {
    return target && target.closest ? target.closest('.iurop-cd__upsell-row') : null;
  }
  function onUpsellWheel(e) {
    var row = upsellRowFrom(e.target);
    if (!row) return;
    if (row.scrollWidth <= row.clientWidth) return; // sin overflow real: no interceptar
    var delta = Math.abs(e.deltaY) > Math.abs(e.deltaX) ? e.deltaY : e.deltaX;
    if (!delta) return;
    // deltaMode 1 = líneas (Firefox), 2 = páginas → normalizar a píxeles
    if (e.deltaMode === 1) delta *= 16;
    else if (e.deltaMode === 2) delta *= row.clientWidth;
    e.preventDefault();
    row.scrollLeft += delta;
  }

  /* flechas mostrar/ocultar (patrón agencia §4b): al inicio solo la derecha,
     en medias ambas, al final solo la izquierda. La rueda/arrastre siguen. */
  function updateUpsellArrows() {
    if (!root) return;
    // Las flechas viven en la CABECERA (.iurop-cd__upsell-head), no dentro del
    // wrap de las tarjetas → se buscan en el bloque .iurop-cd__upsell completo.
    $all('.iurop-cd__upsell', root).forEach(function (block) {
      var row = $('.iurop-cd__upsell-row', block);
      var prev = $('[data-cd-upsell-prev]', block);
      var next = $('[data-cd-upsell-next]', block);
      if (!row || !prev || !next) return;
      var max = row.scrollWidth - row.clientWidth;
      if (max <= 4) { prev.classList.add('is-hidden'); next.classList.add('is-hidden'); return; }
      prev.classList.toggle('is-hidden', row.scrollLeft <= 2);
      next.classList.toggle('is-hidden', row.scrollLeft >= max - 2);
    });
  }
  function onUpsellPointerDown(e) {
    if (e.pointerType !== 'mouse') return; // touch queda nativo
    var row = upsellRowFrom(e.target);
    if (!row || row.scrollWidth <= row.clientWidth) return;
    upsellDrag = { row: row, id: e.pointerId, startX: e.clientX, startLeft: row.scrollLeft, moved: false };
  }
  function onUpsellPointerMove(e) {
    if (!upsellDrag || e.pointerId !== upsellDrag.id) return;
    var dx = e.clientX - upsellDrag.startX;
    if (!upsellDrag.moved) {
      if (Math.abs(dx) < 6) return; // umbral 6px: un clic no es un arrastre
      upsellDrag.moved = true;
      upsellDrag.row.classList.add('is-dragging');
      try { upsellDrag.row.setPointerCapture(e.pointerId); } catch (err) {}
    }
    e.preventDefault();
    upsellDrag.row.scrollLeft = upsellDrag.startLeft - dx;
  }
  function onUpsellPointerUp(e) {
    if (!upsellDrag || e.pointerId !== upsellDrag.id) return;
    var row = upsellDrag.row;
    var moved = upsellDrag.moved;
    row.classList.remove('is-dragging');
    try { row.releasePointerCapture(e.pointerId); } catch (err) {}
    upsellDrag = null;
    if (moved) {
      // traga el click fantasma tras arrastrar (que no dispare "Añadir"/enlaces)
      var swallow = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
      row.addEventListener('click', swallow, true);
      setTimeout(function () { row.removeEventListener('click', swallow, true); }, 0);
    }
  }
  function onUpsellDragStart(e) {
    // evita el drag nativo de enlaces/imágenes mientras se arrastra la fila
    if (upsellDrag && upsellRowFrom(e.target)) e.preventDefault();
  }

  /* ---------- delegación de eventos ---------- */
  function onRootClick(e) {
    var t = e.target;
    if (t.closest('[data-cart-close]') || t === overlay || t.closest('.iurop-cd__overlay')) { e.preventDefault(); close(); return; }
    /* "Finalizar compra": sembrar el código del regalo JUSTO antes de navegar
       (nunca mientras se opera el carrito, que parte las líneas). */
    var toCheckout = t.closest('.iurop-cd__checkout');
    if (toCheckout && lastGiftQualifies) {
      e.preventDefault();
      window.location.href = giftCheckoutUrl(toCheckout.getAttribute('href') || '/checkout');
      return;
    }


    var minus = t.closest('[data-cd-minus]');
    var plus = t.closest('[data-cd-plus]');
    var remove = t.closest('[data-cd-remove]');
    if (minus || plus || remove) {
      var li = t.closest('[data-cd-item]');
      if (!li) return;
      var vid = li.getAttribute('data-variant');
      var key = li.getAttribute('data-key');
      clearDiscountCookie();
      li.classList.add('is-loading');
      /* Por VARIANTE (update.js) para que el BXGY no parta la línea; el key
         queda como respaldo por si una línea vieja no trae data-variant. */
      if (vid) {
        if (remove) changeVariantQty(vid, null, 0);
        else if (minus) changeVariantQty(vid, -1);
        else changeVariantQty(vid, 1);
      } else {
        var qtyEl = $('[data-cd-qty]', li);
        var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
        if (remove) changeItem(key, 0);
        else if (minus) changeItem(key, Math.max(0, qty - 1));
        else changeItem(key, qty + 1);
      }
      return;
    }

    var arrow = t.closest('[data-cd-upsell-prev],[data-cd-upsell-next]');
    if (arrow) {
      e.preventDefault();
      // La flecha vive en la CABECERA, fuera del wrap del track → se busca la
      // fila en el bloque .iurop-cd__upsell completo (si no, no scrollea nada).
      var ablock = arrow.closest('.iurop-cd__upsell');
      var arow = ablock ? $('.iurop-cd__upsell-row', ablock) : null;
      if (arow) {
        var dir = arrow.hasAttribute('data-cd-upsell-prev') ? -1 : 1;
        /* Desplazamiento CUADRADO: avanza tantas tarjetas ENTERAS como quepan a
           la vista y deja el destino en un múltiplo exacto del paso (ancho de
           tarjeta + gap), para que tras cada pulsación una tarjeta quede a ras
           del borde izquierdo (nunca media tarjeta cortada). */
        var acard = $('.iurop-cd__upsell-card', arow);
        var target;
        if (acard) {
          var acs = getComputedStyle(arow);
          var agap = parseFloat(acs.columnGap || acs.gap) || 0;
          var pitch = acard.getBoundingClientRect().width + agap;
          var perView = Math.max(1, Math.floor((arow.clientWidth + agap) / pitch));
          target = Math.round((arow.scrollLeft + dir * pitch * perView) / pitch) * pitch;
        } else {
          target = arow.scrollLeft + dir * Math.max(180, Math.round(arow.clientWidth * 0.8));
        }
        target = Math.max(0, Math.min(target, arow.scrollWidth - arow.clientWidth));
        if (arow.scrollTo) arow.scrollTo({ left: target, behavior: 'smooth' });
        else arow.scrollLeft = target;
      }
      return;
    }

    var add = t.closest('[data-cd-add]');
    if (add) {
      e.preventDefault();
      var vid = add.getAttribute('data-cd-add');
      if (!vid || add.classList.contains('is-loading')) return;
      // etiqueta original estable (si se re-clica durante el feedback, no se
      // captura 'Añadido'/'Error' como texto a restaurar)
      var label = add.getAttribute('data-cd-label');
      if (!label) { label = add.textContent; add.setAttribute('data-cd-label', label); }
      if (add.__cdRestore) { clearTimeout(add.__cdRestore); add.__cdRestore = null; }
      add.classList.remove('is-added'); add.classList.remove('is-error');
      add.textContent = label;
      add.classList.add('is-loading'); add.disabled = true;
      addItem(vid, 1).then(function () { return refresh(); }).then(function () {
        // feedback de éxito visible: sin esto el añadido parecía "no hacer nada"
        add.classList.remove('is-loading'); add.disabled = false;
        add.classList.add('is-added');
        add.textContent = (root.dataset && root.dataset.txtAdded) || 'Añadido';
        add.__cdRestore = setTimeout(function () { add.classList.remove('is-added'); add.textContent = label; add.__cdRestore = null; }, 1600);
      }).catch(function () {
        // feedback breve de error en vez de fallar en silencio
        add.classList.remove('is-loading'); add.disabled = false;
        add.classList.add('is-error');
        add.textContent = (root.dataset && root.dataset.txtError) || 'Error';
        add.__cdRestore = setTimeout(function () { add.classList.remove('is-error'); add.textContent = label; add.__cdRestore = null; }, 1600);
      });
      return;
    }

    if (t.closest('[data-cd-open-calendar]')) { e.preventDefault(); openCalendar(); return; }
    if (t.closest('[data-cd-close-calendar]')) { e.preventDefault(); closeCalendar(); return; }
    if (t.closest('[data-cd-cal-prev]')) { calState.view = new Date(calState.view.getFullYear(), calState.view.getMonth() - 1, 1); buildCalendar(); return; }
    if (t.closest('[data-cd-cal-next]')) { calState.view = new Date(calState.view.getFullYear(), calState.view.getMonth() + 1, 1); buildCalendar(); return; }
    if (t.closest('[data-cd-save-date]')) { e.preventDefault(); saveDate(); return; }

    var day = t.closest('[data-cd-cal-date]');
    if (day && !day.disabled) { calState.selected = day.getAttribute('data-cd-cal-date'); buildCalendar(); return; }

    var tab = t.closest('[data-cd-method]');
    if (tab) {
      calState.method = tab.getAttribute('data-cd-method');
      $all('[data-cd-method]', root).forEach(function (b) { b.classList.toggle('is-active', b === tab); });
      var pinfo = $('[data-cd-pickup-info]', root);
      if (pinfo) pinfo.hidden = (calState.method !== 'Recogida en tienda');
      buildCalendar();
      return;
    }
  }

  /* ---------- disparadores globales de apertura ---------- */
  function isCartLink(a) {
    if (!a || !a.getAttribute) return false;
    if (a.hasAttribute('data-no-drawer')) return false;
    var href = a.getAttribute('href') || '';
    return /(^|\/)cart\/?($|\?|#)/.test(href.split('?')[0]);
  }
  function onDocClick(e) {
    var toggle = e.target.closest('[data-cart-open],[data-cart-drawer-toggle],[data-cart-toggle],.js-cart-toggle,#cart-icon-bubble');
    if (toggle) { e.preventDefault(); open(); return; }
    var link = e.target.closest('a');
    if (link && isCartLink(link)) { e.preventDefault(); open(); }
  }
  function onDocSubmit(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.classList.add('is-loading');
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      // open() ya hace refresh() (repinta líneas + contadores); el broadcast
      // avisa al resto del tema de que el número de artículos cambió.
      .then(function () { if (btn) btn.classList.remove('is-loading'); open(); return refresh(); })
      .then(broadcast)
      .catch(function () { if (btn) btn.classList.remove('is-loading'); form.submit(); });
  }

  /* ---------- init ---------- */
  function init() {
    root = document.getElementById('CartDrawer');
    if (!root) return;
    panel = $('.iurop-cd__panel', root);
    overlay = $('.iurop-cd__overlay', root);
    moneyFormat = root.getAttribute('data-money-format') || moneyFormat;
    // umbral del regalo: manda el ajuste del tema emitido en data-gift-threshold; 4500 (45€) solo como red
    giftThreshold = parseInt(root.getAttribute('data-gift-threshold') || '', 10);
    if (isNaN(giftThreshold) || giftThreshold < 0) giftThreshold = 4500;
    giftVariant = root.getAttribute('data-gift-variant') || '';
    // estado inicial desde el render Liquid: sin esto, un click en "Pago seguro"
    // ANTES del primer renderCart navegaba SIN el código y el checkout cobraba la tote
    lastGiftQualifies = root.getAttribute('data-gift-qualifies') === '1';
    shipThreshold = parseInt(root.getAttribute('data-ship-threshold') || shipThreshold, 10);
    reserveSeconds = parseInt(root.getAttribute('data-reserve-seconds') || reserveSeconds, 10);

    root.addEventListener('click', onRootClick);
    // upsells: rueda -> scroll horizontal + arrastre con ratón (delegados)
    root.addEventListener('wheel', onUpsellWheel, { passive: false });
    root.addEventListener('pointerdown', onUpsellPointerDown);
    root.addEventListener('pointermove', onUpsellPointerMove);
    root.addEventListener('pointerup', onUpsellPointerUp);
    root.addEventListener('pointercancel', onUpsellPointerUp);
    root.addEventListener('dragstart', onUpsellDragStart);
    // scroll NO burbujea pero SÍ captura: mantiene las flechas al día venga el
    // desplazamiento de rueda, arrastre, flechas o scroll táctil
    root.addEventListener('scroll', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('iurop-cd__upsell-row')) updateUpsellArrows();
    }, true);
    window.addEventListener('resize', function () { if (isOpen()) updateUpsellArrows(); });
    document.addEventListener('click', onDocClick, true);
    document.addEventListener('submit', onDocSubmit, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) { if ($('[data-cd-calendar].is-open', root)) closeCalendar(); else close(); } });

    // eventos públicos para otros scripts del tema
    document.addEventListener('cart:open', open);
    document.addEventListener('cart:refresh', function () { refresh(); });
    document.addEventListener('cart:added', function () { refresh(); open(); });
    // contrato con assets/iurop-product-card.js (quick-add de las tarjetas)
    document.addEventListener('cart:updated', function (e) {
      // ignora los que emitimos nosotros (ya hemos pintado): evita el bucle
      if (e && e.detail && e.detail.source === 'iurop-cart') return;
      if (e && e.detail && e.detail.cart) renderCart(e.detail.cart);
      else refresh();
    });
    document.addEventListener('cart-drawer:open', function (e) {
      if (e && e.detail && e.detail.cart) renderCart(e.detail.cart);
      open();
    });

    // fecha caducada: revisión en cada carga de página, sin abrir el drawer
    revalidateStoredDate();
  }

  // API pública
  window.iuropCart = {
    open: open, close: close, refresh: refresh,
    addItem: function (id, qty, props) { return addItem(id, qty, props).then(function () { return refresh(); }).then(open); }
  };
  // Alias esperado por iurop-product-card.js: window.iuropCartDrawer.open(cart)
  window.iuropCartDrawer = {
    open: function (cart) { if (cart) renderCart(cart); open(); },
    close: close,
    refresh: refresh
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();